export const GET_INVENTORY_REPORT = 'GET_INVENTORY_REPORT';
export const GET_INVENTORY_REPORT_SUCCESS = 'GET_INVENTORY_REPORT_SUCCESS';
export const GET_INVENTORY_REPORT_FAILED = 'GET_INVENTORY_REPORT_FAILED';
